module.exports = __webpack_public_path__ + "static/img/centerRoundMini.9083b260.png";